import { createAction } from "redux-actions";

export const getVendors = createAction("GET_VENDORS");
export const getVendorsSuccess = createAction("GET_VENDORS_SUCCESS");
export const getVendorsError = createAction("GET_VENDORS_ERROR");
export const setVendorStatus = createAction("SET_VENDOR_STATUS");
export const setVendorsLoaded = createAction("SET_VENDORS_LOADED");
export const setVendorsLoading = createAction("SET_VENDORS_LOADING");
